// extracted by mini-css-extract-plugin
module.exports = {"navItem":"Navigation_navItem__HbaxQ"};